export default __webpack_public_path__ + "static/media/tomatoPlant_x600.3af9b9ea.png";